import React from "react";
import { marqueeCities } from "../mock";

export default function Marquee() {
  const items = [...marqueeCities, ...marqueeCities];
  return (
    <div className="section-cream border-y border-[#cfd7bf] overflow-hidden">
      <div className="marquee-track py-5">
        {items.map((city, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif-display text-2xl md:text-3xl text-[#2a3325] px-8">{city}</span>
            <span className="dot-sep" />
          </div>
        ))}
      </div>
    </div>
  );
}
